import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import SelectableList from "../components/SelectableList";
import { Button } from "semantic-ui-react";
import { FilterContext } from "../FilterContext";
import { initialDataClearedFilter } from "./FilterTypes/DataClearedFilterType";

interface DataClearedFilterProps {
  title?: string
}

const DataClearedFilter = (props: DataClearedFilterProps) => {
  const title = props.title || "Data";
  const onlyNotDataClearedLabel = "Only not data cleared";
  const onlyDataClearedLabel = "Only data cleared";

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);

  register("dataCleared", {
    getTitle: () => title,
    renderSelection: (filter) => <>
      {filter.dataCleared === "onlyDataCleared" ? onlyDataClearedLabel : undefined}
      {filter.dataCleared === "onlyNotDataCleared" ? onlyNotDataClearedLabel : undefined}
    </>,
    hasValue: (filter) => filter.dataCleared !== "noFilter",
    reset: () => ({
      dataCleared: "noFilter"
    }),
    areEqual: (a, b) => a.dataCleared === b.dataCleared
  });

  useEffect(() => {
    setInitialValue("dataCleared", initialDataClearedFilter);
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [dataCleared, setDataCleared] = React.useState<server.dto.DataClearedFilterSettings>(initialDataClearedFilter.dataCleared);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setDataCleared(getValue("dataCleared").dataCleared);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("dataCleared", { dataCleared: dataCleared });
    setPopupOpen(false);
  };

  const options: Array<{ value: server.dto.DataClearedFilterSettings, label: string }> = [
    { value: "onlyDataCleared", label: onlyDataClearedLabel },
    { value: "onlyNotDataCleared", label: onlyNotDataClearedLabel }
  ];
  type Option = typeof options[number];

  const onChange = (option: Option) => {
    setDataCleared(option.value);
    setValue("dataCleared", { dataCleared: option.value });
    onPopupClose();
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      width={272}
      content={<form onSubmit={onApply}>
        <div className="margin-bottom">
          <SelectableList
            noSearch
            noScrolling
            items={options}
            selectedItems={[options.find(v => v.value === dataCleared)].filter(Boolean)}
            onItemToggled={onChange}
            getId={opt => opt.value.toString()}
            getName={opt => opt.label}
          />
        </div>

        <Button fluid type="submit" primary >
          {RESX.SelectionManager.Apply}
        </Button>
      </form>}

      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default DataClearedFilter;